import { faBell } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { format } from "date-fns/format";
import React from "react";
import { useTranslation } from "react-i18next";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectHistoryAlarmItem } from "../../queries/object-history/Common";
import { ObjectHistoryCard } from "./ObjectHistoryCard";
import { ObjectHistoryCardContent } from "./ObjectHistoryCardContent";
import { ObjectHistoryCardHeader } from "./ObjectHistoryCardHeader";
import { ObjectHistoryCardSubheader } from "./ObjectHistoryCardSubheader";

export type ObjectHistoryAlarmItemProps = {
    item: IObjectHistoryAlarmItem;
    contextObject?: IeLynxObject;
};

export function ObjectHistoryAlarmItem({ item, contextObject }: ObjectHistoryAlarmItemProps) {
    const { t } = useTranslation();

    function getAlarmColor(): string | undefined {
        return item.isAcknowledged
            ? item.acknowledgedColor
            : item.isAlarm
                ? item.alarmColor
                : undefined;
    }

    return (
        <ObjectHistoryCard>
            <ObjectHistoryCardHeader
                title={format(item.timestamp, "P pp")}
                avatar={<FontAwesomeIcon icon={faBell} size="2x" color={getAlarmColor()} />}
                subheader={
                    <ObjectHistoryCardSubheader
                        item={item}
                        createdBy={t("objectHistory.alarmItem.eLynxAlarm")}
                        contextObject={contextObject}
                    />
                }
            >
            </ObjectHistoryCardHeader>
            <ObjectHistoryCardContent>
                <Typography variant="body2" noWrap={false}>
                    {t("objectHistory.alarmItem.alarmText", {
                        tagName: item.tagName,
                        setpointName: item.setpointName,
                        value: item.listText ?? item.value,
                        uom: item.units
                    })}
                </Typography>
            </ObjectHistoryCardContent>
        </ObjectHistoryCard>
    );
}
